module.exports = __webpack_public_path__ + "img/emoji.cfdc5c97.svg";